module.exports = __webpack_public_path__ + "static/media/log-out.3cbc68e7.svg";